import { Outlet } from "@tanstack/react-router";

/**
 * Root layout — wraps every route. The session probe runs in the root
 * route's `beforeLoad` (see [src/router.ts]) so child routes can read
 * the result via `useRouteContext`.
 */
export function RootLayout() {
  return (
    <div className="min-h-dvh bg-background text-foreground">
      <Outlet />
    </div>
  );
}
